import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description HouseSafety icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HouseSafety } from '@sravni/design-system-icons'
 *
 * <HouseSafety />
 * ```
 */
var HouseSafety = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "HouseSafety", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.143 14.286H7.857c-.273 0-.714-.373-.714-.715v-2.857c0-.341.44-.714.714-.714h4.286c.273 0 .714.373.714.714v2.857c0 .342-.441.715-.714.715Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M8.571 10V8.572a1.428 1.428 0 1 1 2.857 0V10", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M17.142 7.857v8.572c0 .79-.64 1.428-1.428 1.428H4.285c-.79 0-1.429-.639-1.429-1.428V7.857", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M.714 9.613 9.18 2.448a1.253 1.253 0 0 1 1.64 0l8.466 7.164", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }))); });

export { HouseSafety };
//# sourceMappingURL=HouseSafety.js.map
